import { render, staticRenderFns } from "./PermissionsExpansionPanelLayers.vue?vue&type=template&id=562a140c&scoped=true&"
import script from "./PermissionsExpansionPanelLayers.vue?vue&type=script&lang=js&"
export * from "./PermissionsExpansionPanelLayers.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsExpansionPanelLayers.vue?vue&type=style&index=0&id=562a140c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a140c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VExpansionPanels,VList,VListItem})
